import type { RoleConfig } from '../types.js';

export const doctor: RoleConfig = {
  id: 'doctor',
  faction: 'town',
  title: { ru: 'Доктор', uk: 'Лікар' },
  latin: 'DOCTOR',
  number: '03',
  accent: '#a8e8d4',
  sub: '#7a9c92',
  ability: {
    ru: 'Ночью спасает одного игрока. Себя — один раз за игру.',
    uk: 'Вночі рятує одного гравця. Себе — один раз за гру.',
  },
  abilities: [
    {
      key: 'save',
      phase: 'night',
      cadence: 'every-night',
      canSelfTarget: true,
      selfTargetLimit: 1,
    },
  ],
  victory: { type: 'town' },
};
